import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


(function () {
  let lastSignature = null;
  let timeout = null;

  function getSignature(cart) {
    return cart.items.map(i => i.key + ":" + i.quantity).join("|");
  }

  function loadRecommendationsSafely() {
    clearTimeout(timeout);

    // debounce (wait for cart to settle)
    timeout = setTimeout(() => {
      const container = document.getElementById("cart-drawer-recommendations");
      if (!container) return;

      fetch("/cart.js")
        .then(r => r.json())
        .then(cart => {
          if (!cart.items.length) {
            container.innerHTML = "";
            container.style.display = "none";
            lastSignature = null;
            return;
          }

          const signature = getSignature(cart);
          if (signature === lastSignature) return;
          lastSignature = signature;

          container.style.display = "block";

          const productId = cart.items[cart.items.length - 1].product_id;
          const url =
            container.dataset.url +
            `?product_id=${productId}&limit=6&section_id=recommendation-drawer-custom`;

          fetch(url)
            .then(r => r.text())
            .then(html => {
              if (!html || !html.trim()) {
                container.style.display = "none";
                return;
              }
              container.innerHTML = html;
            });
        });
    }, 200); // ⬅️ debounce delay (critical)
  }

  // Listen only to meaningful cart events
  document.addEventListener("cart:open", loadRecommendationsSafely);
  document.addEventListener("cart:change", loadRecommendationsSafely);
  document.addEventListener("cart:update", loadRecommendationsSafely);

})();
